/* src/app/admin/partner-list/partner-list.component.scss */
/*# sourceMappingURL=partner-list.component-NYJ3GCQA.css.map */
